export default __webpack_public_path__ + "static/media/Agroseme-logo.9fb7e33c.jpg";